<template>
  <div class="common-messages">
  </div>
</template>

<script>
import eventHub from '@/utils/eventHub';
import successCode from '@/utils/successCode';
import errorCode from '@/utils/errorCode';

export default {
  name: 'CommonMessages',
  mounted() {
    eventHub.$on('success', (code) => {
      this.$bvToast.toast((code in successCode) ? successCode[code] : code, {
        title: '成功',
        variant: 'success',
        toaster: 'b-toaster-top-left',
        appendToast: true,
      });
    });
    eventHub.$on('error', (code) => {
      this.$bvToast.toast((code in errorCode) ? errorCode[code] : code, {
        title: 'エラー',
        variant: 'danger',
        toaster: 'b-toaster-top-left',
        appendToast: true,
      });
    });
  },
};
</script>

<style scoped>
</style>

<style>
#b-toaster-top-left {
  margin-top: 56px;
}
</style>
